<template>
  <main>
    <component :is="component" v-if="component" v-bind="entity" />
  </main>
</template>

<script lang="ts" setup>
import type { NodePageFragment } from '#build/graphql-operations'
import NodePage from '~/components/Node/Page/index.vue'

definePageMeta({
  name: 'drupal-route',
})

const nuxtRoute = useRoute()

// Get the data.
const { data: query } = await useAsyncData(nuxtRoute.path, async () => {
  const v = await useCachedGraphqlQuery('route', {
    path: nuxtRoute.path,
  })

  return v.data
})

const { entity, drupalRoute } = await useDrupalRoute<NodePageFragment>(query)

/**
 * The vue component for the entity.
 */
const component = computed(() => {
  if (
    drupalRoute.value.entityType === 'node' &&
    drupalRoute.value.entityBundle === 'page'
  ) {
    return NodePage
  }
})

// Cache all pages for 10 minutes.
useRouteCache((ctx) => ctx.setMaxAge(10 * 60).setCacheable())

const { trackPageView } = useAnalyticsTracking()
trackPageView()
</script>

<script lang="ts">
export default {
  name: 'PageRoute',
}
</script>

<style lang="scss" scoped>
:deep(.paragraph),
.paragraph {
  @include paragraph-spacing;
}
</style>
